import type {
  LinkedByQueueReqData,
  LinkedByQueueResData,
  RedeemCodeReqData,
  RedeemCodeResData,
  SubmitSignatureReqData,
  SubmitSignatureResData,
  SuratKuasaByQueueReqData,
  SuratKuasaByQueueResData,
  ValidateCodeReqData,
  ValidateCodeResData,
  VerifyKtpDigitReqData,
  VerifyKtpDigitResData,
} from '~/types/pickup'

import { pickupApi } from './api'

const validateCode = async (reqData: ValidateCodeReqData): Promise<ValidateCodeResData> => {
  const response = await pickupApi.post<ValidateCodeResData>('pickup/validate-code', reqData)

  return response.data
}

const verifyKtpDigit = async (reqData: VerifyKtpDigitReqData): Promise<VerifyKtpDigitResData> => {
  const response = await pickupApi.post<VerifyKtpDigitResData>('pickup/verify-ktp-digit', reqData)

  return response.data
}

const submitSignature = async (reqData: SubmitSignatureReqData): Promise<SubmitSignatureResData> => {
  const formData = new FormData()
  formData.append('kode_unik', reqData.kode_unik)
  formData.append('signature', reqData.signature, 'signature.png')

  const response = await pickupApi.post<SubmitSignatureResData>('pickup/submit-signature', formData)

  return response.data
}

const redeemCode = async (reqData: RedeemCodeReqData): Promise<RedeemCodeResData> => {
  const response = await pickupApi.post<RedeemCodeResData>('pickup/redeem-code', reqData)

  return response.data
}

// Surat Kuasa attached to a queue, for the CS counter to eyeball the signed
// document while serving. 404 here just means the queue didn't come from a
// Dikuasakan kode unik, so callers treat it as "nothing to show".
const suratKuasaByQueue = async (reqData: SuratKuasaByQueueReqData): Promise<SuratKuasaByQueueResData> => {
  const response = await pickupApi.post<SuratKuasaByQueueResData>('pickup/surat-kuasa-by-queue', reqData)

  return response.data
}

// Whether the queue came from a kode unik (unit/dokumen/kuasa/batch). Only those
// queues may be cancelled by CS - see JBACR-1255.
const linkedByQueue = async (reqData: LinkedByQueueReqData): Promise<LinkedByQueueResData> => {
  const response = await pickupApi.post<LinkedByQueueResData>('pickup/linked-by-queue', reqData)

  return response.data
}

export default { validateCode, verifyKtpDigit, submitSignature, redeemCode, suratKuasaByQueue, linkedByQueue }
